import { motion } from "framer-motion";
import * as Icons from "lucide-react";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Icon({ name, className, strokeWidth = 1.5 }) {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
}
